// src/nonce-loader.ts
(function () {
    const appRoot = document.querySelector('app-root');
    const nonce = appRoot?.getAttribute('ngCspNonce');
    if (!nonce) return;
  
    const originalCreateElement = document.createElement;
    document.createElement = function (tagName: string) {
      const element = originalCreateElement.call(document, tagName) as HTMLElement;
  
      if (tagName.toLowerCase() === 'script' || tagName.toLowerCase() === 'style') {
        element.setAttribute('nonce', nonce);
      }
      return element;
    };
  })();